<template>
  <div class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-100">
    <div>
      <Link v-bind:href="$route('dashboard')">
        <Logo />
      </Link>
    </div>

    <div class="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">
      <form v-on:submit.prevent="form.post($route('password.update'))">
        <!-- Email Address -->
        <div class="form-group">
          <label for="email">
            Email
          </label>

          <input v-model="form.email" class="form-control" id="email" type="email" required="required" autofocus="autofocus">
          <span v-if="form.errors.email" class="invalid-feedback" role="alert">
            <strong>{{ form.errors.email }}</strong>
          </span>
        </div>

        <!-- Password -->
        <div class="form-group">
          <label for="password">
            Password
          </label>

          <input v-model="form.password" class="form-control" id="password" type="password" required="required">
          <span v-if="form.errors.password" class="invalid-feedback" role="alert">
            <strong>{{ form.errors.password }}</strong>
          </span>
        </div>

        <!-- Confirm Password -->
        <div class="form-group">
          <label for="password_confirmation">
            Confirm Password
          </label>

          <input v-model="form.password_confirmation" class="form-control" id="password_confirmation" type="password"  required="required">
          <span v-if="form.errors.password_confirmation" class="invalid-feedback" role="alert">
            <strong>{{ form.errors.password_confirmation }}</strong>
          </span>
        </div>

        <div class="flex items-center justify-end mt-4">
          <button type="submit" class="btn btn-primary">
            Reset Password
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { Link, useForm } from "@inertiajs/vue3";
import Logo from "../Layouts/Logo";

const { token } = defineProps(['token']);

const form = useForm({
  email: null,
  password: null,
  password_confirmation: null,
  token: token,
});
</script>
